import Section from "./Section";
import Group59 from "../../../assets/Group59.png";
import Group65 from "../../../assets/Group65.png";
import Group66 from "../../../assets/Group66.png";

const Features = () => {
  return (
    <>
      <Section
        serial="first"
        bgColor="#FFFFFF"
        text="Make scheduling a breeze with our time table creator"
        imgSrc={Group59}
      />
      <Section
        serial="second"
        bgColor="#F6E9FF"
        text="Say goodbye to cluttered schedules and hello to organization"
        imgSrc={Group65}
      />
      <Section
        serial="third"
        bgColor="#FFFFFF"
        text="Transform scheduling chaos into calm with our advanced features"
        imgSrc={Group66}
      />
    </>
  );
};

export default Features;